'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatClear = function EditorFormatClear(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z' })
  );
};
EditorFormatClear = (0, _pure2.default)(EditorFormatClear);
EditorFormatClear.displayName = 'EditorFormatClear';
EditorFormatClear.muiName = 'SvgIcon';

exports.default = EditorFormatClear;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/editor/format-clear.js
// module id = 1377
// module chunks = 0